<template>
  <div class="work-check-bpmn-instances-route">
    <PageTitle hide-margin-left>
      BPMN — Активные процессы
    </PageTitle>
    <WorkCheckBpmnInstances />
  </div>
</template>

<script setup>
import PageTitle from '@/components/common/PageTitle.vue'
import WorkCheckBpmnInstances from './WorkCheckBpmnInstances.vue'
</script>

<style scoped lang="scss">
.work-check-bpmn-instances-route {
  padding: 20px;
  max-width: 1600px;
}
</style>
